import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-agent-settings-inbound-chat-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAgentSettingsInboundChatIconProps extends SvgIconProps {}

export function CcfAgentSettingsInboundChatIcon(
  props: CcfAgentSettingsInboundChatIconProps
) {
  return (
    <SvgIcon
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 25 26"
        id="CHAT_IB"
        {...props}
      >
        <path
          d="M5.11672 8.68375C5.11672 8.13146 4.66901 7.68375 4.11672 7.68375C3.56444 7.68375 3.11672 8.13146 3.11672 8.68375V14.8839H1.18722C0.948201 14.8839 0.805165 15.1498 0.936884 15.3492L3.87669 19.8007C3.99595 19.9813 4.26137 19.98 4.37892 19.7983L7.25833 15.3468C7.38745 15.1472 7.24417 14.8839 7.00644 14.8839H5.11672V8.68375Z"
          fill="rgb(36, 89, 0)"
        ></path>
        <path
          d="M5.11672 8.68375C5.11672 8.13146 4.66901 7.68375 4.11672 7.68375C3.56444 7.68375 3.11672 8.13146 3.11672 8.68375V14.8839H1.18722C0.948201 14.8839 0.805165 15.1498 0.936884 15.3492L3.87669 19.8007C3.99595 19.9813 4.26137 19.98 4.37892 19.7983L7.25833 15.3468C7.38745 15.1472 7.24417 14.8839 7.00644 14.8839H5.11672V8.68375Z"
          fill="rgb(36, 89, 0)"
        ></path>
        <path
          d="M19.317 5.43604H14.5561C13.0715 5.43079 11.6456 6.02095 10.5918 7.07678C9.53803 8.13261 8.94264 9.56769 8.93652 11.0665V11.1634C8.94264 12.6623 9.53803 14.0974 10.5918 15.1532C11.6456 16.2091 13.0715 16.7992 14.5561 16.794H16.8476L21.7534 20.3514C21.8305 20.4033 21.9205 20.4325 22.0131 20.4357C22.1057 20.4388 22.1974 20.4159 22.2779 20.3694C22.3499 20.3267 22.4098 20.2659 22.4517 20.1929C22.4936 20.1199 22.5161 20.0373 22.517 19.953L21.7836 16.2052C22.725 15.7492 23.52 15.0346 24.0776 14.1433C24.6353 13.2521 24.9329 12.2203 24.9365 11.1661V11.0692C24.9311 9.56991 24.336 8.13414 23.2822 7.07773C22.2283 6.02132 20.802 5.43079 19.317 5.43604Z"
          fill="rgb(36, 89, 0)"
        ></path>
    </SvgIcon>
  );
}

export default CcfAgentSettingsInboundChatIcon;
